import React, { useState, useEffect } from "react";
import { Container } from "react-bootstrap";
import { FaFacebookF, FaInstagram, FaWhatsapp } from "react-icons/fa";
import { useNavigate, useLocation } from "react-router-dom";
import "./Navbar.css";

const Navbar = () => {
  const [showNav, setShowNav] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setShowNav(window.scrollY > 80);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToSection = (id) => {
    if (location.pathname === "/") {
      const section = document.getElementById(id);
      if (section) {
        section.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      navigate("/", { state: { scrollTo: id } });
    }
    setMenuOpen(false);
  };

  return (
    <>
      <div className={`navbar ${showNav ? "show" : ""}`}>
        <Container fluid className="navbar-inner">
          <div className="navbar-logo">
            <img src={require("../assets/khasiyat-logo.png")} alt="logo" />
          </div>

          <div className="navbar-right">
            <div className="navbar-links">
              <span onClick={() => scrollToSection("home")}>Home</span>
              <span onClick={() => scrollToSection("menu")}>Menu</span>
              <span onClick={() => scrollToSection("review")}>Review</span>
              <span onClick={() => scrollToSection("connect")}>Stay Connected</span>
            </div>

            <div className="navbar-social">
              <a href="https://www.instagram.com/khaasiyatpahalgam/"><FaInstagram /></a>
              <a href="https://www.facebook.com/profile.php?id=61575212754670"><FaFacebookF /></a>
              <a href="https://wa.me/919103358985" target="_blank" rel="noopener noreferrer">
                <FaWhatsapp />
              </a>
            </div>
          </div>

          <div className="navbar-menu" onClick={() => setMenuOpen(!menuOpen)}>
            {menuOpen ? "✕" : "☰"}
          </div>
        </Container>
      </div>

      <div className={`sidebar ${menuOpen ? "open" : ""}`}>
        <span onClick={() => scrollToSection("home")}>Home</span>
        <span onClick={() => scrollToSection("menu")}>Menu</span>
        <span onClick={() => scrollToSection("review")}>Review</span>
        <span onClick={() => scrollToSection("connect")}>Get in Touch</span>

        <div className="sidebar-social">
          <a href="https://www.instagram.com/khaasiyatpahalgam/"><FaInstagram /></a>
          <a href="https://www.facebook.com/profile.php?id=61575212754670"><FaFacebookF /></a>
          <a href="https://wa.me/919103358985" target="_blank" rel="noopener noreferrer">
            <FaWhatsapp />
          </a>
        </div>
      </div>
    </>
  );
};

export default Navbar;